module.exports = __webpack_public_path__ + "img/commitSeven.e598084d.png";